import SpecialistReservationAPI from "api/SpecialistReservationAPI";
import useFetchData from "hooks/useFetchData";

export default function useSpecialistReservations( params: SpecialistReservationsGETPaginatedParams = {}) {
   return useFetchData({
      APIMethod: SpecialistReservationAPI.getAll,
      params: [ params ],
      clear_data_on_update: true,
      debounce: true
   })
}